import { render, staticRenderFns } from "./TituloDialog.vue?vue&type=template&id=75a567db&scoped=true"
import script from "./TituloDialog.vue?vue&type=script&lang=js"
export * from "./TituloDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a567db",
  null
  
)

export default component.exports